import React from 'react';
import PropTypes from 'prop-types';
import { position as positionPropType } from '../../../../prop-types/sizeMe';
import Material from '../../../../models/Material';
import { inchToString } from '../../../../lib/unitConversions';

export const StatusComponent = ({
  classes,
  position,
  copperCount,
  pressedThickness,
  totalThickness,
  hoveredLayer,
  lengthUnit,
}) => (
  <div
    className={classes.root}
    style={{ top: position.top, left: position.left + 10 }}
  >
    <pre>
      Number of Layers: 
      {copperCount}
      <br />
      Initial PCB Thickness:
      {' '}
      {totalThickness ? inchToString(totalThickness, lengthUnit) : 'N/A'}
      <br />
      Pressed PCB Thickness:
      {' '}
      {pressedThickness ? inchToString(pressedThickness, lengthUnit) : 'N/A'}
      <br />
      <br />
      {hoveredLayer && hoveredLayer.summary(lengthUnit)}
    </pre>
  </div>
);

StatusComponent.propTypes = {
  classes:          PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  position:         positionPropType.isRequired,
  copperCount:      PropTypes.number.isRequired,
  pressedThickness: PropTypes.number.isRequired,
  totalThickness:   PropTypes.number.isRequired,
  hoveredLayer:     PropTypes.instanceOf(Material),
  lengthUnit:       PropTypes.string.isRequired,
};

StatusComponent.defaultProps = {
  hoveredLayer: null
}

export default StatusComponent;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/StatusComponent.js